/**
 * @flow
 * Created by neo on 18.07.17.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { Row, Col } from 'reactstrap';

type Props = {
  children: React.Node,
  wide: boolean,
  hide: boolean,
};

@observer
export default class FormCol extends React.Component<Props, void> {
  static defaultProps = {
    hide: false,
    wide: false,
  };

  render() {
    const { hide, wide, children } = this.props;
    if (!hide) {
      if (wide) {
        return <Col xs="12">{children}</Col>;
      }
      return (
        <Col xs="12" md="6">
          {children}
        </Col>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/App/Components/FormCol.js